import { api } from '@/api/main.api'

export async function apiGetDesigners () {
  return api('get', '/v3/project/designer/overview')
}

export async function apiGetWorkLog () {
  return api('get', '/v3/designer-work-log/monthly')
}



// WEBPACK FOOTER //
// ./src/api/designers.api.js